// extracted by mini-css-extract-plugin
module.exports = {"pipelineDetailsRow":"review_pipelineDetailsRow__1Tlz1","rowSubTitle":"review_rowSubTitle__1YoqH","rowValues":"review_rowValues__H9Ynf"};